import Crud from '../views/Company/Crud'
import Entity from '../views/Company/Add'

let routes = {
    path: '/companies',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/companies/add',
            name: 'NewCompany',
            component: Entity,
            meta: {
                pageTitle: 'company.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'company.add.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/companies/edit/:id?',
            name: 'EditCompany',
            component: Entity,
            meta: {
                pageTitle: 'company.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'company.add.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/companies',
            name: 'list-companies',
            component: Crud,
            meta: {
                pageTitle: 'company.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'company.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
